import { buildSlice, CommonState } from '~libs/reduxUtils';
import { Appointment } from '~weekly-planner/lib/common';

import { typePrefix } from '~weekly-planner/actions/appointments';

const initialState: CommonState<Appointment> = {
  loading: 'idle',
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<Appointment>, Appointment>(typePrefix, initialState);

export const { clear, updateParams } = slice.actions;

export default slice.reducer;
